/* RESPONSIBLE TEAM: team-reporting */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import ConversationAttributeDescriptor from 'embercom/models/conversation-attributes/descriptor';
import { inject as service } from '@ember/service';
import type ReportingUnderlyingDataService from 'embercom/services/reporting-underlying-data-service';
import { taskFor } from 'ember-concurrency-ts';
import type IntlService from 'ember-intl/services/intl';
import type RouterService from '@ember/routing/router-service';
import type BannerDismissalService from 'embercom/services/banner-dismissal-service';

export default class NewOverviewRoute extends IntercomRoute {
  @service intl!: IntlService;
  @service appService: $TSFixMe;
  @service declare router: RouterService;
  @service declare reportingUnderlyingDataService: ReportingUnderlyingDataService;
  @service declare bannerDismissalService: BannerDismissalService;
  @service declare intercomEventService: any;
  @service declare navbarCollapsingService: $TSFixMe;

  analytics = { place: 'new-overview' };
  reportName = 'overview_report_v2';
  reportContext = 'overview';
  titleToken = this.intl.t('reporting.overview.title');
  awarenessBannerKey = 'r2-awareness-banner';
  migrationBannerKey = 'r2-migration-banner';

  activate() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'viewed',
      object: this.reportName,
      context: this.reportContext,
    });
    this.intercomEventService.trackEvent('viewed_overview_report');

    if (this.navbarCollapsingService.collapsed) {
      this.navbarCollapsingService.toggleNavbarCollapsed();
    }
  }

  async beforeModel() {
    let promises = [
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation.workflow_conversation_rating.workflow_id',
        'conversation',
        true,
      ),
    ];

    if (this.appService.app.canUseFinGuidanceGA) {
      promises.push(
        taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
          'conversation.fin.guidelines_applied.guideline_ids',
          'conversation',
          true,
        ),
      );
    }
    await Promise.all(promises);
  }

  async model() {
    let hasDismissedAwarenessBanner = await this.bannerDismissalService.hasDismissed(
      this.awarenessBannerKey,
    );
    let hasDismissedMigrationBanner = await this.bannerDismissalService.hasDismissed(
      this.migrationBannerKey,
    );

    return {
      conversationAttributeDescriptors: ConversationAttributeDescriptor.peekAllAndMaybeLoad(),
      hasDismissedAwarenessBanner,
      hasDismissedMigrationBanner,
      awarenessBannerKey: this.awarenessBannerKey,
      migrationBannerKey: this.migrationBannerKey,
    };
  }
}
